var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnMedim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-hub"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M18 0V18H0L0 0L18 0ZM6.51972 4.06154H3.01396V4.26471L4.14303 5.62485C4.25387 5.72476 4.31048 5.87148 4.29545 6.01992V11.3645C4.32834 11.5573 4.26757 11.7543 4.13174 11.895L2.86154 13.4358V13.639H6.46326V13.4358L5.19306 11.895C5.05624 11.7545 4.9917 11.5589 5.01806 11.3645V6.74231L8.17944 13.639H8.54639L11.2618 6.74231L11.2618 12.2712C11.2612 12.3908 11.2544 12.4217 11.1658 12.5102L10.1892 13.4584V13.6615H14.9313V13.4584L13.9885 12.5328C13.9053 12.4694 13.864 12.3651 13.8812 12.2619V5.46119C13.864 5.35799 13.9053 5.25372 13.9885 5.19029L14.9538 4.26471V4.06154H11.6118L9.22948 10.0044L6.51972 4.06154Z",
    fill: "#767A7F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMedim);
export default __webpack_public_path__ + "static/media/icn_medim.2bf240992e2623361e133aa478e9fdc6.svg";
export { ForwardRef as ReactComponent };